import { CrfFormByCodesRoute, ICrfFormByCodesRouteProps, InstitutionContext, OnlinePatientManagementContext, PatientContext } from "@ngt/opms";
import { FC, useContext } from "react";
import { useParams } from "react-router-dom";

export interface IProFormByCodesRouteProps extends ICrfFormByCodesRouteProps {}


const ProFormByCodesRoute: FC<IProFormByCodesRouteProps> = ({
    institutionCode,
    patientStudyNumber,
    
    ...props
}) => {
    const params = useParams();
    const { routeParameters } = useContext(OnlinePatientManagementContext);
    const { data: patient } = useContext(PatientContext);
    const { data: institution } = useContext(InstitutionContext);

    const institutionCodeToUse = params[routeParameters.institutionCode] ?? institutionCode ?? institution?.code ?? undefined;
    const patientStudyNumberToUse = params[routeParameters.patientStudyNumber] ?? patientStudyNumber ?? patient?.studyNumber ?? undefined;

    return (
        <CrfFormByCodesRoute
            {...props}
            institutionCode={institutionCodeToUse}
            patientStudyNumber={patientStudyNumberToUse}
        />
    );
}

export default ProFormByCodesRoute;